// English translations
const en = {
  // Navigation
  nav: {
    prayerRequest: "Prayer Request",
    sacredSites: "Sacred Sites",
    prayerWall: "Prayer Wall",
    testimonials: "Testimonials",
    holyWord: "Divine Word",
    pricing: "Pricing",
    login: "Login",
    signup: "Sign Up",
    dashboard: "Dashboard",
    admin: "Admin",
    logout: "Logout"
  },
  
  // Home page
  home: {
    badge: "Connecting Hearts to the Holy Land",
    title: "Connect Your Heart to the",
    titleHighlight: "Sacred Land",
    subtitle: "Your deepest prayers deserve a sacred journey. We deliver your intentions to Jerusalem's holiest sites and send you photo proof of your prayer's delivery.",
    cta: "Begin Your Prayer Journey",
    discoverSites: "Discover Sacred Sites",
    prayerFor: "Prayer for",
    family: "Family",
    health: "Health",
    peace: "Peace",
    howItWorks: "How It Works",
    howItWorksSubtitle: "A sacred journey in three simple steps",
    step1Title: "Write Your Prayer",
    step1Desc: "Share what's in your heart. Your prayer is kept completely confidential and treated with reverence.",
    step2Title: "Choose Sacred Sites",
    step2Desc: "Select from Jerusalem's most revered locations where your prayer will be personally delivered.",
    step3Title: "Receive Confirmation",
    step3Desc: "Get a photograph confirming your prayer's delivery to the Holy Land.",
    sacredSites: "Sacred Sites",
    sacredSitesSubtitle: "Where your prayers find their home",
    viewAllSites: "View All Sacred Sites",
    testimonials: "Testimonials",
    testimonialsSubtitle: "Stories of faith and answered prayers",
    readMore: "Read More Testimonials",
    startJourney: "Start Your Prayer Journey Today",
    startJourneySubtitle: "Join thousands who have found peace through our sacred prayer delivery service",
    submitPrayer: "Submit Your Prayer"
  },
  
  // Prayer Request page
  prayerRequest: {
    title: "Send Your Prayer to Jerusalem's Holy Sites",
    subtitle: "A sacred journey in three simple steps",
    step: "Step",
    type: "Type",
    sites: "Sites",
    prayer: "Prayer",
    details: "Details",
    chooseType: "Choose Your Prayer Type",
    oneTime: "One-Time Prayer",
    oneTimeDesc: "Choose your sacred sites and send a single prayer",
    journey: "Prayer Journey",
    journeyDesc: "A continuing prayer journey at your chosen sacred sites",
    choosePackage: "Choose Your Prayer Package",
    holySite: "Holy Site",
    holySites: "Holy Sites",
    mostPopular: "MOST POPULAR",
    chooseSites: "Choose Your Sacred Sites",
    chooseSitesDesc: "Select one or more holy sites where your prayer will be delivered",
    selectAll: "Select All",
    clear: "Clear",
    writePrayer: "Write Your Prayer",
    writePrayerDesc: "Share your heartfelt prayer. It will be kept private and treated with reverence.",
    prayerPlaceholder: "Write your prayer here...",
    characters: "characters",
    minRequired: "Minimum 50 required",
    prayerLibrary: "Prayer Library",
    yourDetails: "Your Details",
    yourDetailsDesc: "We'll send your prayer confirmation to this email",
    dedicatedTo: "This Prayer is Dedicated to",
    dedicatedPlaceholder: "Enter name(s)",
    yourName: "Your Name",
    namePlaceholder: "Enter your name",
    yourEmail: "Your Email",
    emailPlaceholder: "Enter your email",
    reviewRequest: "Review Your Prayer Request",
    prayerType: "Prayer Type",
    sacredSites: "Sacred Sites",
    selected: "selected",
    prayerLength: "Prayer Length",
    back: "Back",
    previous: "Previous",
    next: "Next",
    continue: "Continue",
    submit: "Submit",
    submitPrayer: "Submit Prayer",
    submitting: "Submitting..."
  },
  
  // Checkout
  checkout: {
    backToPricing: "Back to Pricing",
    orderSummary: "Order Summary",
    billedMonthly: "Billed monthly",
    billedAnnually: "Billed annually",
    total: "Total",
    chargedMonthly: "Charged monthly until cancelled",
    chargedAnnually: "Charged annually until cancelled",
    secureCheckout: "Secure Checkout",
    securePayment: "Your payment is processed securely by Stripe. We never store your card details.",
    features: {
      photos: "High-quality photos",
      delivery: "Personal delivery to holy sites",
      confirmation: "Email confirmation with GPS coordinates",
      cancel: "Cancel anytime, no fees"
    },
    contactInfo: "Contact Information",
    emailAddress: "Email Address",
    emailPlaceholder: "you@example.com",
    emailHelper: "We'll send your confirmation and receipt here",
    stripeRedirect: "After clicking the button below, you'll be redirected to Stripe's secure payment page to complete your purchase.",
    agreeTerms: "I agree to the",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    subscriptionNote: "I understand this is a recurring subscription that will automatically renew until I cancel.",
    pay: "Pay",
    continueToPay: "Continue to Payment",
    processing: "Processing...",
    redirecting: "Redirecting to payment...",
    secureStripe: "Your payment is secured by Stripe with 256-bit SSL encryption",
    moneyBack: "7-Day Money-Back Guarantee",
    moneyBackDesc: "If you're not completely satisfied with your prayer delivery service within 7 days, we'll refund your payment in full—no questions asked. Your spiritual peace of mind is our priority."
  },
  
  // Footer
  footer: {
    stayConnected: "Stay Connected with Jerusalem",
    newsletterDesc: "Receive spiritual insights, reflections, and updates from the sacred sites",
    emailPlaceholder: "Enter your email",
    subscribe: "Subscribe",
    subscribed: "Thank you for subscribing!",
    quickLinks: "Quick Links",
    resources: "Resources",
    connectWithUs: "Connect With Us",
    followUs: "Follow us for daily blessings and inspiration from the Holy Land.",
    copyright: "© 2025 Jerusalem Holy Prayer. All rights reserved.",
    privacy: "Privacy Policy",
    terms: "Terms of Service"
  },
  
  // Auth
  auth: {
    welcomeBack: "Welcome Back",
    signIn: "Sign in to your account",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    login: "Sign In",
    loggingIn: "Signing in...",
    noAccount: "Don't have an account?",
    signUp: "Sign up",
    createAccount: "Create Account",
    joinUs: "Join our community of faithful believers",
    name: "Full Name",
    confirmPassword: "Confirm Password",
    creating: "Creating account...",
    hasAccount: "Already have an account?",
    passwordRequirement: "At least 6 characters"
  },
  
  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    close: "Close",
    search: "Search",
    filter: "Filter",
    all: "All",
    learnMore: "Learn More"
  },

  // Pricing page
  pricing: {
    title: "Simple, Transparent Pricing",
    subtitle: "Choose the sacred journey that resonates with your heart",
    oneTime: "One-Time Prayer",
    oneTimeDesc: "Perfect for special intentions and occasions",
    subscription: "Prayer Journey",
    subscriptionDesc: "Ongoing spiritual connection with the Holy Land",
    holySite: "Holy Site",
    holySites: "Holy Sites",
    popular: "MOST POPULAR",
    perMonth: "/month",
    perYear: "/year",
    billedAnnually: "billed annually",
    monthly: "Monthly",
    annual: "Annual",
    savePercent: "Save 17%",
    selectPlan: "Select Plan",
    getStarted: "Get Started",
    features: "Features",
    includes: "Includes",
    chooseThis: "Choose This Plan"
  },

  // Sacred Sites page
  sacredSites: {
    title: "Sacred Sites of Jerusalem",
    subtitle: "Discover the holy places where your prayers will be delivered",
    exploreAll: "Explore All Sites",
    viewDetails: "View Details"
  },

  // Prayer Wall page
  prayerWall: {
    title: "Prayer Wall",
    subtitle: "Join our community in prayer. Read and be inspired by the prayers of fellow believers.",
    recentPrayers: "Recent Prayers",
    anonymous: "Anonymous",
    prayedAt: "Prayed at"
  },

  // Testimonials page
  testimonials: {
    title: "Stories of Faith",
    subtitle: "Read how Jerusalem Holy Prayer has touched lives around the world",
    readMore: "Read More",
    verifiedPurchase: "Verified Purchase"
  },

  // Contact page
  contact: {
    title: "Contact Us",
    subtitle: "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
    name: "Your Name",
    email: "Your Email",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    sending: "Sending...",
    address: "Address",
    phone: "Phone",
    emailUs: "Email Us",
    successTitle: "Message Sent",
    successDesc: "We'll get back to you soon."
  },

  // FAQ page
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Find answers to common questions about our prayer delivery service"
  },

  // About page
  about: {
    title: "About Us",
    subtitle: "Our mission is to connect hearts with the Holy Land",
    ourStory: "Our Story",
    ourTeam: "Our Jerusalem Messengers"
  },

  // Dashboard
  dashboard: {
    title: "My Dashboard",
    welcome: "Welcome back",
    myPrayers: "My Prayers",
    myPayments: "My Payments",
    noPrayers: "No prayers yet",
    noPayments: "No payments yet",
    viewAll: "View All",
    status: "Status",
    date: "Date",
    amount: "Amount"
  },

  // Checkout Success
  checkoutSuccess: {
    title: "Payment Successful!",
    subtitle: "Thank you for your order. Your prayer journey begins now.",
    orderNumber: "Order Number",
    emailSent: "A confirmation email has been sent to",
    whatNext: "What happens next?",
    step1: "Our messengers receive your prayer request",
    step2: "We personally deliver your prayer to the sacred sites",
    step3: "You receive photos and confirmation via email",
    returnHome: "Return to Home",
    viewDashboard: "View Dashboard"
  },

  // About page extended
  aboutPage: {
    ourStory: "Our Story",
    ourStoryP1: "Jerusalem Holy Prayer was born from a simple conversation in 2019 between three friends sitting in a café near the Jaffa Gate. Rachel, a tour guide who had spent fifteen years leading Christian pilgrims through the Holy Land, shared her heartbreak over the countless people she met who dreamed of visiting Jerusalem but couldn't—due to health issues, financial constraints, family obligations, or age.",
    ourStoryP2: "\"So many people cry when they tell me they'll never see these places in person,\" she said. \"But what if we could bring their prayers here instead?\" That question sparked everything that followed.",
    ourStoryP3: "The three founders—Rachel, David (a Christian theologian and longtime Jerusalem resident), and Sarah (a photographer documenting holy sites)—started small. They offered to deliver prayers for friends and family members abroad. Word spread through churches, prayer groups, and faith communities. What began as a handful of prayers carried to the Western Wall grew into a mission serving thousands of believers worldwide.",
    ourStoryP4: "Today, our team includes several dedicated individuals, all Jerusalem residents with deep knowledge of the city and its holy sites. We are a private, independent service, not tied to any church, denomination, or religious organization. What unites us is a profound respect for Jerusalem's significance to millions of people around the world and a commitment to serving anyone who wishes to have their prayer physically delivered to these places.",
    ourStoryP5: "We navigate the Old City's ancient stones daily, maintaining relationships with site guardians and custodians who understand our mission. We've learned the rhythms of each location—when the Church of the Holy Sepulchre is quietest for contemplation, which days offer the best access to the Garden Tomb, how to time deliveries to avoid disrupting worship services and pilgrim groups.",
    ourStoryP6: "Since our founding, we've delivered over 50,000 prayers to Jerusalem's sacred sites. Each one represents a person's deepest hopes, fears, gratitude, or petitions. We've carried prayers for healing during illnesses, for guidance during life transitions, for reconciliation in broken relationships, for strength during grief, and for thanksgiving during joy. The privilege of this work humbles us daily.",
    ourStoryP7: "We believe that faith transcends geography, but there's something powerful about physical presence in places hallowed by centuries of prayer and devotion. Through our service, we help bridge the distance between hearts yearning for connection and the ancient stones that have witnessed humanity's spiritual journey for millennia.",
    ourValues: "Our Core Values",
    valueReverence: "Reverence",
    valueReverenceDesc: "Every prayer is handled with the deepest respect and spiritual care",
    valueCommunity: "Community",
    valueCommunityDesc: "Connecting believers worldwide through shared faith and prayer",
    valueAccessibility: "Accessibility",
    valueAccessibilityDesc: "Making the Holy Land accessible to everyone, everywhere",
    valueAuthenticity: "Authenticity",
    valueAuthenticityDesc: "Genuine spiritual experiences rooted in ancient sacred traditions",
    ourTeamTitle: "Our Jerusalem Messengers",
    ourTeamP1: "Our messengers consist of twelve individuals who call Jerusalem home—not tourists or temporary residents, but people deeply rooted in this ancient city. Most have lived here for ten years or more; some were born within the Old City walls. This isn't just our workplace; it's where we worship, raise our families, and experience daily life amid sites that shaped Western civilization's spiritual landscape.",
    ourTeamP2: "Each team member brings unique strengths. Rachel and David, our co-founders, oversee operations and maintain relationships with site custodians. Sarah leads our documentation team, ensuring every photograph authentically captures the moment of prayer delivery.",
    ourTeamP3: "Others handle logistics—Miriam coordinates schedules around site access and religious observances; Benjamin manages our multilingual communications; Leah and Thomas deliver prayers to sites throughout the city. Everyone undergoes training in respectful site protocols, photography documentation, and handling prayers with the reverence they deserve.",
    ourTeamP4: "We're not a large organization, and we prefer it that way. This allows us to maintain personal touch and genuine care for every prayer we handle. Many of us exchange emails with regular users, building relationships that extend beyond single transactions. When we deliver a prayer for someone battling illness or celebrating a milestone, we carry their story with us to the holy sites.",
    ourTeamP5: "Living in Jerusalem means navigating complex realities—political tensions, security concerns, and the daily challenges of a divided city. Yet we're convinced this work matters. In a world often marked by division, we facilitate connections rooted in faith, hope, and shared humanity. Every prayer we deliver is an act of bridge-building, a small gesture toward the peace Jerusalem's name promises."
  },

  // FAQ page extended
  faqPage: {
    stillHaveQuestions: "Still Have Questions?",
    stillHaveQuestionsDesc: "Our team is here to help. Feel free to reach out to us anytime.",
    contactUs: "Contact Us"
  },

  // Terms page
  termsPage: {
    title: "Terms of Service",
    lastUpdated: "Last Updated: January 2025",
    agreementTitle: "Agreement to Terms",
    agreementText: "By accessing and using Jerusalem Holy Prayer's services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you may not use our services.",
    servicesTitle: "Our Services",
    servicesIntro: "Jerusalem Holy Prayer provides a prayer delivery service where:",
    servicesItem1: "Users submit prayers through our website",
    servicesItem2: "Our Jerusalem-based messengers deliver these prayers to selected holy sites",
    servicesItem3: "Users receive photographic confirmation of delivery",
    servicesItem4: "Subscription options provide ongoing prayer delivery services",
    responsibilitiesTitle: "User Responsibilities",
    responsibilitiesIntro: "When using our service, you agree to:",
    responsibilitiesItem1: "Provide accurate and complete information",
    responsibilitiesItem2: "Submit prayers that are respectful and appropriate",
    responsibilitiesItem3: "Not use the service for any unlawful purposes",
    responsibilitiesItem4: "Respect the sacred nature of the sites where prayers are delivered",
    responsibilitiesItem5: "Not share or resell your account access",
    contentTitle: "Content Guidelines",
    contentIntro: "All prayer submissions must be:",
    contentItem1: "Respectful and appropriate for sacred settings",
    contentItem2: "Free from hate speech, violence, or discriminatory content",
    contentItem3: "Not promoting illegal activities",
    contentItem4: "Sincere spiritual expressions",
    contentNote: "We reserve the right to refuse service for prayers that violate these guidelines.",
    paymentTitle: "Payment and Subscriptions",
    paymentOneTime: "One-Time Prayers: Payment is required at the time of submission.",
    paymentSubscriptions: "Subscriptions:",
    paymentItem1: "Billed monthly or annually as selected",
    paymentItem2: "Automatically renewed unless cancelled",
    paymentItem3: "Can be cancelled at any time through your account",
    paymentItem4: "Cancellation takes effect at the end of the current billing period",
    paymentItem5: "No refunds for partial months",
    refundTitle: "Refund Policy",
    refundItem1: "Refunds may be requested within 7 days of prayer delivery if service was not provided as described",
    refundItem2: "No refunds after prayer has been delivered and confirmed",
    refundItem3: "Subscription refunds are not available for unused portions of the subscription period",
    refundItem4: "All refund requests must be submitted in writing to our support team",
    availabilityTitle: "Service Availability",
    availabilityIntro: "While we strive to deliver all prayers within the promised timeframe, we cannot guarantee service availability during:",
    availabilityItem1: "Major religious holidays when sites may be closed or restricted",
    availabilityItem2: "Security situations in Jerusalem",
    availabilityItem3: "Natural disasters or emergencies",
    availabilityItem4: "Technical issues beyond our control",
    availabilityNote: "In such cases, we will notify you and either reschedule or offer a refund.",
    intellectualTitle: "Intellectual Property",
    intellectualText: "All content on this website, including text, graphics, logos, and photographs, is the property of Jerusalem Holy Prayer and protected by copyright laws. You may not reproduce, distribute, or create derivative works without our written permission.",
    liabilityTitle: "Limitation of Liability",
    liabilityText: "Jerusalem Holy Prayer provides this service as a spiritual offering. We do not guarantee specific outcomes or results from prayer. Our liability is limited to the amount paid for the service. We are not responsible for any indirect, incidental, or consequential damages.",
    modificationsTitle: "Modifications to Service",
    modificationsText: "We reserve the right to modify, suspend, or discontinue any part of our service at any time. We will provide notice of significant changes when possible.",
    governingTitle: "Governing Law",
    governingText: "These Terms of Service are governed by the laws of the State of Israel. Any disputes shall be resolved in the courts of Jerusalem.",
    contactTitle: "Contact Information",
    contactText: "For questions about these Terms of Service, please contact us at:"
  },

  // Privacy page
  privacyPage: {
    title: "Privacy Policy",
    lastUpdated: "Last Updated: January 2025",
    introTitle: "Introduction",
    introText: "At Jerusalem Holy Prayer, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information when you use our prayer delivery service.",
    collectTitle: "Information We Collect",
    personalInfo: "Personal Information:",
    personalItem1: "Name and contact information (email address)",
    personalItem2: "Prayer text and dedication information",
    personalItem3: "Payment information (processed securely through third-party providers)",
    personalItem4: "Correspondence with our support team",
    autoInfo: "Automatically Collected Information:",
    autoItem1: "Browser type and device information",
    autoItem2: "IP address and location data",
    autoItem3: "Website usage statistics",
    useTitle: "How We Use Your Information",
    useItem1: "To deliver your prayers to the selected sacred sites",
    useItem2: "To send you confirmation emails and delivery photos",
    useItem3: "To process payments securely",
    useItem4: "To improve our services and user experience",
    useItem5: "To communicate with you about your requests",
    useItem6: "To send newsletters (only with your consent)",
    confidentialityTitle: "Prayer Confidentiality",
    confidentialityText: "Your prayers are treated with the utmost reverence and confidentiality. They are handled only by our trusted Jerusalem-based messengers and are never shared, sold, or used for any purpose other than delivery to the holy sites you've selected.",
    securityTitle: "Data Security",
    securityText: "We implement industry-standard security measures to protect your personal information. This includes encryption, secure servers, and restricted access to sensitive data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.",
    thirdPartyTitle: "Third-Party Services",
    thirdPartyIntro: "We use trusted third-party services for:",
    thirdPartyItem1: "Payment processing (your payment information is handled securely by our payment provider)",
    thirdPartyItem2: "Email delivery services",
    thirdPartyItem3: "Website analytics",
    thirdPartyNote: "These services have their own privacy policies, and we encourage you to review them.",
    rightsTitle: "Your Rights",
    rightsIntro: "You have the right to:",
    rightsItem1: "Access your personal information",
    rightsItem2: "Request correction of inaccurate data",
    rightsItem3: "Request deletion of your information",
    rightsItem4: "Opt-out of marketing communications",
    rightsItem5: "Withdraw consent for data processing",
    cookiesTitle: "Cookies",
    cookiesText: "We use cookies to enhance your browsing experience and analyze website traffic. You can control cookie settings through your browser preferences.",
    changesTitle: "Changes to This Policy",
    changesText: "We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on this page and updating the \"Last Updated\" date.",
    contactTitle: "Contact Us",
    contactText: "If you have any questions about this Privacy Policy or our data practices, please contact us at:"
  },

  // Dashboard extended
  dashboardPage: {
    memberSince: "Member since",
    totalPrayers: "Total Prayers",
    totalPayments: "Total Payments",
    newPrayerRequest: "New Prayer Request",
    myPrayers: "My Prayers",
    paymentHistory: "Payment History",
    noPrayersYet: "No prayers yet",
    noPrayersDesc: "Start your spiritual journey by submitting your first prayer",
    submitFirstPrayer: "Submit Your First Prayer",
    noPaymentsYet: "No payments yet",
    noPaymentsDesc: "Your payment history will appear here",
    viewPricingPlans: "View Pricing Plans",
    oneTime: "One-Time",
    journey: "Journey",
    dedicatedTo: "Dedicated to:",
    holySitesSelected: "holy site(s) selected"
  },

  // Admin Dashboard
  adminPage: {
    title: "Admin Dashboard",
    subtitle: "Manage prayers, contacts, and users",
    refresh: "Refresh",
    totalUsers: "Total Users",
    prayerRequests: "Prayer Requests",
    pending: "pending",
    contactMessages: "Contact Messages",
    new: "new",
    totalRevenue: "Total Revenue",
    payments: "payments",
    tabs: {
      prayers: "Prayer Requests",
      contacts: "Contact Messages",
      users: "Users",
      payments: "Payments"
    },
    table: {
      status: "Status",
      from: "From",
      dedicatedTo: "Dedicated To",
      sites: "Sites",
      date: "Date",
      actions: "Actions",
      customer: "Customer",
      amount: "Amount",
      type: "Type",
      user: "User",
      email: "Email",
      role: "Role",
      joined: "Joined"
    },
    actions: {
      process: "Process",
      deliver: "Deliver",
      markRead: "Mark Read",
      markResponded: "Mark Responded",
      makeAdmin: "Make Admin",
      removeAdmin: "Remove Admin"
    },
    empty: {
      noPrayers: "No prayer requests yet",
      noContacts: "No contact messages yet",
      noUsers: "No users yet",
      noPayments: "No payments yet"
    },
    roles: {
      admin: "Admin",
      user: "User"
    }
  },

  // Contact page extended
  contactPage: {
    beforeReachOut: "Before You Reach Out",
    forFasterAssistance: "For faster assistance, please check if your question is answered in our:",
    faqLink: "FAQ Page",
    faqDesc: "- Covers most common questions about our service",
    aboutLink: "About Us",
    aboutDesc: "- Learn about our messengers and mission",
    termsLink: "Terms of Service",
    termsDesc: "- Refund policies, subscriptions, and service details",
    technicalNote: "If you're experiencing a technical issue with the website, please include details about your browser, device, and the specific error message you're seeing.",
    callUs: "Call Us",
    jerusalemOffice: "Jerusalem Office:",
    usSupportLine: "US Support Line:",
    officeHours: "Jerusalem: Sun-Thu 9AM-5PM (IST)",
    usHours: "US Line: Mon-Fri 9AM-6PM (EST)",
    officeLocation: "Office Location",
    officeAddress1: "Jerusalem Holy Prayer",
    officeAddress2: "Christian Quarter",
    officeAddress3: "Old City, Jerusalem 91140",
    officeNote: "Near Jaffa Gate",
    officeVisit: "Walk-in visits by appointment only",
    responseTimes: "Response Times",
    responseEmail: "Email inquiries: Within 24 hours (business days)",
    responsePrayer: "Prayer support: Same day or next business day",
    responsePhone: "Phone calls: Immediate during business hours",
    responseUrgent: "Urgent prayer requests: Priority response within 4 hours",
    formIntro: "Whether you have questions about our service, need help with a prayer submission, or want to share your experience, we're here to listen. Our team typically responds within 24 hours during business days.",
    generalInquiries: "General Inquiries:",
    prayerSupport: "Prayer Support:",
    technicalSupport: "Technical Support:"
  },

  // Sacred Sites extended
  sacredSitesPage: {
    heroSubtitle: "Discover the holy places where your prayers will be delivered with reverence and care",
    allSites: "All Sites",
    sendPrayerHere: "Send a Prayer Here"
  },

  // Header mobile menu
  mobileMenu: {
    adminPanel: "Admin Panel",
    signOut: "Sign Out"
  }
};

export default en;
